import { useReducer } from 'react';
import { Queue } from '@rossum/api-client/queues';
import { QueueTileAction } from '../components/queue-tile/QueueTile';
import { WorkspaceSectionAction } from '../components/WorkspaceSection';

export type DialogState =
  | { type: 'closed' }
  | { type: 'queueMove'; queue: Queue }
  | { type: 'queueDelete'; queue: Queue }
  | { type: 'queueDuplicate'; queue: Queue }
  | { type: 'workspaceDelete'; workspaceId: number }
  | { type: 'workspaceAddQueue'; workspaceId: number }
  | { type: 'addWorkspace' };

export type DialogAction =
  | { type: 'openQueueDialog'; action: QueueTileAction; queue: Queue }
  | {
      type: 'openWorkspaceDialog';
      action: WorkspaceSectionAction;
      workspaceId: number;
    }
  | { type: 'openAddWorkspace' }
  | { type: 'close' };

const dialogReducer = (
  state: DialogState,
  action: DialogAction
): DialogState => {
  switch (action.type) {
    case 'openQueueDialog':
      switch (action.action) {
        case 'move':
          return { type: 'queueMove', queue: action.queue };
        case 'delete':
          return { type: 'queueDelete', queue: action.queue };
        case 'duplicate':
          return { type: 'queueDuplicate', queue: action.queue };
        default:
          return state;
      }
    case 'openWorkspaceDialog':
      switch (action.action) {
        case 'delete':
          return { type: 'workspaceDelete', workspaceId: action.workspaceId };
        case 'addQueue':
          return { type: 'workspaceAddQueue', workspaceId: action.workspaceId };
        default:
          return state;
      }
    case 'openAddWorkspace':
      return { type: 'addWorkspace' };
    case 'close':
      return { type: 'closed' };
    default:
      return state;
  }
};

export const useQueueListDialogs = () => {
  return useReducer(dialogReducer, { type: 'closed' });
};
